import { Col, Row } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { API } from '../../common/Constants';

const AgentChart = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const prodId = location?.state?.prodId;
    const agentId = location?.state?.agentId;
    const Year = localStorage.getItem('selectedYear');
    const payload = JSON.parse(localStorage.getItem('interestQueryPayload') || '{}');
    const queryPayload = { ...payload };// value: toggleValue
    const queryString = new URLSearchParams(queryPayload).toString();

    return (
        <div className="w-full min-h-screen bg-[#F5F5F5] overflow-hidden">
            <div className="bg-white">
                <Row gutter={[24, 24]} className='p-[18px_25px]'>
                    <Col xs={24} sm={12} md={24} lg={24}>
                        <div className="text-[18px] font-[700] bg-white flex">
                            <div className="mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer" onClick={() => navigate(-1)}>
                                <img src="/images/left-circle.svg" alt="arrow" />
                            </div>
                            <p>Agent Chart</p>
                        </div>
                    </Col>
                </Row >
            </div >
            <div className='min-[768px]:mx-[50px]'>
                <iframe
                    src={`${API.BaseUrl}view-agent-chart/${prodId}/${agentId}/${Year}?${queryString}`}
                    className='h-[900px]'
                    id='pdf'
                    title="PDF Viewer"
                    width="100%"
                />
            </div>

        </div >
    );
};

export default AgentChart;